import React, { useState, useRef } from "react";
import InfoPage from ".";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [messageLine1, setMessageLine1] = useState("");
  const [messageLine2, setMessageLine2] = useState("");
  const [messageLine3, setMessageLine3] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const line2Ref = useRef(null);
  const line3Ref = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const fullMessage = [messageLine1, messageLine2, messageLine3].filter(Boolean).join(' ');

    try {
      const response = await fetch('https://hook.us1.make.com/xq7a914xoogfzcvj8xynmtxdf6yikz3r', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          email,
          message: fullMessage,
        }),
      });

      if (response.ok) {
        setSubmitStatus('success');
        // Clear form
        setName('');
        setEmail('');
        setMessageLine1('');
        setMessageLine2('');
        setMessageLine3('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleLine1Change = (e) => {
    const value = e.target.value;
    const charWidth = 6.2; // approximate character width in pixels
    const maxWidth = e.target.offsetWidth - 16; // input width minus padding
    const maxChars = Math.floor(maxWidth / charWidth);
    
    if (value.length > maxChars) {
      setMessageLine1(value.slice(0, maxChars));
      setMessageLine2(value.slice(maxChars));
      setTimeout(() => line2Ref.current?.focus(), 0);
    } else {
      setMessageLine1(value);
    }
  };

  const handleLine2Change = (e) => {
    const value = e.target.value;
    const charWidth = 6.2;
    const maxWidth = e.target.offsetWidth - 16;
    const maxChars = Math.floor(maxWidth / charWidth);
    
    if (value.length > maxChars) {
      setMessageLine2(value.slice(0, maxChars));
      setMessageLine3(value.slice(maxChars));
      setTimeout(() => line3Ref.current?.focus(), 0);
    } else {
      setMessageLine2(value);
    }
  };

  const handleLine3Change = (e) => {
    const value = e.target.value;
    const charWidth = 6.2;
    const maxWidth = e.target.offsetWidth - 16;
    const maxChars = Math.floor(maxWidth / charWidth);
    
    setMessageLine3(value.slice(0, maxChars));
  };
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
  
  const belowContent = (
    <>
      {/* Left side - Image */}
      <div style={{
        position: isMobile ? 'relative' : 'absolute',
        left: isMobile ? 'auto' : '0',
        right: isMobile ? 'auto' : '50%',
        top: isMobile ? 'auto' : '350px',
        bottom: isMobile ? 'auto' : '80px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 3,
        padding: isMobile ? '0' : '0 24px',
        marginBottom: isMobile ? '24px' : '0'
      }}>
        <img
          src="/contact.png"
          alt="Contact"
          style={{
            width: isMobile ? '100%' : '380px',
            maxWidth: isMobile ? '280px' : '380px',
            height: isMobile ? 'auto' : '506px',
            maxHeight: isMobile ? '340px' : '506px',
            objectFit: 'cover',
            borderRadius: '8px',
            marginBottom: isMobile ? '12px' : '20px'
          }}
        />
        <p style={{
          fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
          fontSize: isMobile ? '14px' : '16px',
          fontWeight: '200',
          color: '#0f084b',
          margin: 0,
          textAlign: 'center'
        }}>
          @chlobellexx x @chestnuthillcabin
        </p>
      </div>

      {/* Right side - Form */}
      <div style={{
        position: isMobile ? 'relative' : 'absolute',
        left: isMobile ? 'auto' : '50%',
        right: isMobile ? 'auto' : '0',
        top: isMobile ? 'auto' : '320px',
        bottom: isMobile ? 'auto' : '80px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 3,
        padding: isMobile ? '0 20px' : '0 48px'
      }}>
        <form 
          onSubmit={handleSubmit}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
            width: '100%',
            maxWidth: '350px'
          }}
        >
          {/* Header */}
          <h3 style={{
            fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
            fontSize: isMobile ? '20px' : '24px',
            fontWeight: '700',
            color: '#0f084b',
            margin: '0 0 8px 0',
            textAlign: 'center'
          }}>
            Drop us a line!
          </h3>

          {/* Name field */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            <input
              type="text"
              placeholder=""
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              style={{
                border: 'none',
                borderBottom: '2px solid rgba(0,0,0,.12)',
                background: 'transparent',
                padding: '8px 0',
                fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
                fontSize: '16px',
                color: '#0f084b',
                outline: 'none'
              }}
            />
            <label style={{
              fontFamily: "'Sailors', serif",
              fontSize: '16px',
              color: '#0f084b',
              textAlign: 'left'
            }}>
              Name
            </label>
          </div>

          {/* Email field */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            <input
              type="email"
              placeholder=""
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                border: 'none',
                borderBottom: '2px solid rgba(0,0,0,.12)',
                background: 'transparent',
                padding: '8px 0',
                fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
                fontSize: '16px',
                color: '#0f084b',
                outline: 'none'
              }}
            />
            <label style={{
              fontFamily: "'Sailors', serif",
              fontSize: '16px',
              color: '#0f084b',
              textAlign: 'left'
            }}>
              Email
            </label>
          </div>

          {/* Message field - three separate lines */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }}>
            <input
              type="text"
              placeholder=""
              value={messageLine1}
              onChange={handleLine1Change}
              style={{
                border: 'none',
                borderBottom: '2px solid rgba(0,0,0,.12)',
                background: 'transparent',
                padding: '2px 0 4px 0',
                fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
                fontSize: '16px',
                color: '#0f084b',
                outline: 'none'
              }}
            />
            <input
              type="text"
              placeholder=""
              ref={line2Ref}
              value={messageLine2}
              onChange={handleLine2Change}
              style={{
                border: 'none',
                borderBottom: '2px solid rgba(0,0,0,.12)',
                background: 'transparent',
                padding: '2px 0 4px 0',
                fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
                fontSize: '16px',
                color: '#0f084b',
                outline: 'none'
              }}
            />
            <input
              type="text"
              placeholder=""
              ref={line3Ref}
              value={messageLine3}
              onChange={handleLine3Change}
              style={{
                border: 'none',
                borderBottom: '2px solid rgba(0,0,0,.12)',
                background: 'transparent',
                padding: '2px 0 4px 0',
                fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
                fontSize: '16px',
                color: '#0f084b',
                outline: 'none'
              }}
            />
            <label style={{
              fontFamily: "'Sailors', serif",
              fontSize: '16px',
              color: '#0f084b',
              textAlign: 'left',
              marginTop: '8px'
            }}>
              Message
            </label>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              background: isSubmitting ? '#999' : '#dc1d08',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '14px 32px',
              fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
              fontSize: '18px',
              fontWeight: '800',
              letterSpacing: '0.08em',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              textTransform: 'uppercase'
            }}
            onMouseOver={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
              }
            }}
            onMouseOut={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
              }
            }}
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>

          {/* Status Message */}
          {submitStatus === 'success' && (
            <p style={{
              fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
              fontSize: '14px',
              color: '#28a745',
              textAlign: 'center',
              margin: '-16px 0 0 0'
            }}>
              Message sent successfully!
            </p>
          )}
          {submitStatus === 'error' && (
            <p style={{
              fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
              fontSize: '14px',
              color: '#dc1d08',
              textAlign: 'center',
              margin: '-16px 0 0 0'
            }}>
              Error sending message. Please try again.
            </p>
          )}
        </form>
      </div>
    </>
  );

  // Wrap content in a container div for mobile layout
  const wrappedBelowContent = (
    <div style={{
      position: isMobile ? 'relative' : 'absolute',
      inset: isMobile ? 'auto' : 0,
      display: isMobile ? 'flex' : 'block',
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '24px' : '0',
      padding: isMobile ? '20px' : '0',
      alignItems: isMobile ? 'center' : 'stretch',
      justifyContent: isMobile ? 'flex-start' : 'stretch'
    }}>
      {belowContent}
    </div>
  );
  
  return <InfoPage 
    title="Contact" 
    divider 
    belowContent={wrappedBelowContent} 
    disableStamps 
    tallOverride={false}
    customMinHeight={isMobile ? 900 : undefined}
  />;
};

export default Contact;


